import React from 'react';
import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import glitchLogo from 'url:./resources/glitch.svg';
import youtubeLogo from 'url:./resources/youtube.svg';
import './carousel.css';

function getVodThumbnailSrc(vodUrl: string): string {
	return vodUrl.includes('youtube.com') ? youtubeLogo : glitchLogo;
}

export default function Carousel({images, vod, raceType, raceNumber}: {images: string[], vod?: string, raceType: string, raceNumber: number}){
	const children: React.ReactElement[] = [];

	if(images?.length && images.length > 0){
		children.push(...Images(images, raceType, raceNumber));
	}

	if(vod){
		children.push(Vod(vod));
	}

	return <ResponsiveCarousel
		renderThumbs={children => {
			const thumbs = children.map((child: any, index: number) => {
				if(child.type === 'iframe' && vod){
					return <img key="vod-thumb" width={70} height={61} src={getVodThumbnailSrc(vod)} alt="VOD" />;
				} else {
					return child;
				}
			})

			return thumbs;
		}}
		renderItem={(item: React.ReactNode, options) => {
			if(React.isValidElement(item) && item.type === 'iframe'){
				if(options?.isSelected){
					return item;
				} else {
					return;
				}
			}
			return item;
		}}
	>
		{children}
	</ResponsiveCarousel>
}

const Images = (images: string[], raceType: string, raceNumber: number) => {
	return images.map((image, index) => <img key={index} className='raceImage' src={`/r/${raceType}/${raceNumber}/${image}`} />)
}

const Vod = (embedUrl: string) => {
	return <iframe
		key={embedUrl}
		src={embedUrl}
		height="100%"
		width="100%"
		allowFullScreen={true}
		>
	</iframe>
}